import React, { FormEvent, useEffect, useState } from 'react'

import { Chain, JsonSupplierBrand, SupplierBrand } from '../../models'
import { UpdateCountryParams, getSupplierBrands } from '../../api'

interface FormProps {
    handleSubmit: (
        e: FormEvent<HTMLFormElement>,
        inputs: UpdateCountryParams
    ) => void
    chain?: Chain
}

export const ChainForm = (props: FormProps) => {
    const { handleSubmit, chain } = props
    const [brands, setSupplierBrand] = useState([])

    const defaultInputs = {
        abbreviation: chain?.abbreviation,
        code: chain?.code,
        name: chain?.name,
        supplier_brand_id: chain?.supplier_brand_id
    }

    const [inputs, setInputs] = useState(defaultInputs)

    const updateInputs = (field: string, value: number | string) => {
        setInputs({
            ...inputs,
            [field]: value
        })
    }
    
    useEffect(() => {
        getSupplierBrands().then(json => {
            setSupplierBrand(json.data.map((brand: JsonSupplierBrand) => new SupplierBrand(brand)))
        })
    }, [])

    return (
        <form onSubmit={(e) => handleSubmit(e, inputs)}>
            <div className='row mb-4'>
                <div className='col-12'>
                    <label htmlFor='nameInput'>Name</label>
                    <input
                        className='form-control'
                        id='nameInput'
                        onChange={(e) => updateInputs(
                            'name',
                            e.target.value
                        )}
                        required
                        type='text'
                        value={inputs.name} />
                    <label htmlFor='abbreviationInput'>Chain Code</label>
                    <input
                        className='form-control'
                        id='abbreviationInput'
                        onChange={(e) => updateInputs(
                            'abbreviation',
                            e.target.value
                        )}
                        required
                        maxLength={2}
                        type='text'
                        value={inputs.abbreviation} />
                    <label htmlFor='codeInput'>Code</label>
                    <input
                        className='form-control'
                        id='codeInput'
                        onChange={(e) => updateInputs(
                            'code',
                            e.target.value
                        )}
                        required
                        type='text'
                        value={inputs.code} />
                    <label htmlFor='supplierBrandIdInput'>Supplier Brand Id</label>
                    <select
                        className='form-select'
                        id='supplierBrandIdInput'
                        onChange={(e) => updateInputs('supplier_brand_id', e.target.value)}
                        required
                        value={inputs.supplier_brand_id}>
                        <option value=''>
                            Select Supplier Brand
                        </option>
                        {brands.map((brand: SupplierBrand) => (
                            <option
                                key={`${brand.id}`}
                                value={brand.id}>
                                {brand.name}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className='row mb-5'>
                <div className='col-12 d-flex justify-content-center'>
                    <button className='btn btn-primary' type='submit'>
                        Submit
                    </button>
                </div>
            </div>
        </form>
    )
}
